import lang from '../../lib/language';

import discoverLogo from '../../assets/img/icon_discover.svg';
import myAccountLogo from '../../assets/img/icon_myaccount.png';
import IconCup from '../../assets/img/icon-cup.svg';
import helpLogo from '../../assets/img/icon-help_24px.svg';
import watchlistLogo from '../../assets/img/icon-watchlist.svg';
import ordersTradersLogo from '../../assets/img/orders-trades-logo.svg';
import profileLogo from '../../assets/img/profile.png';
import { UI_ROUTES } from '../../util/routes';

import { SideBarItem } from './Sidebar.types';

export const CAPITAL_MENU_LIST_MOBILE: SideBarItem[] = [
  {
    id: 'myProfile',
    label: lang.mobileProfileHeaderTitle(),
    path: UI_ROUTES.myProfile,
    img: <img src={profileLogo} alt="icon my profile" />,
  },
  {
    id: 'myAccountMenuItem',
    label: lang.commonMyAccount(),
    path: UI_ROUTES.myAccount,
    img: <img src={myAccountLogo} alt="icon my account" />,
  },
  {
    id: 'watchlistMenuItem',
    label: lang.commonWatchlist(),
    path: UI_ROUTES.overview,
    img: <img src={watchlistLogo} alt="icon watchlist" />,
  },
  {
    id: 'discoverMenuItem',
    label: lang.commonDiscoverTitle(),
    path: UI_ROUTES.discover,
    img: <img src={discoverLogo} alt="icon discover" />,
  },
  {
    id: 'myPositionMenuItem',
    label: lang.commonMyPositionRanking(),
    path: UI_ROUTES.myPosition,
    img: <img src={IconCup} alt="icon up and down arrows" />,
  },
];

export const CAPITAL_MENU_LIST: SideBarItem[] = [
  {
    id: 'myAccountMenuItem',
    label: lang.commonMyAccount(),
    path: UI_ROUTES.myAccount,
    img: <img src={myAccountLogo} alt="icon my account" />,
  },
  {
    id: 'watchlistMenuItem',
    label: lang.commonWatchlist(),
    path: UI_ROUTES.overview,
    img: <img src={watchlistLogo} alt="icon watchlist" />,
  },
  {
    id: 'discoverMenuItem',
    label: lang.commonDiscoverTitle(),
    path: UI_ROUTES.discover,
    img: <img src={discoverLogo} alt="icon discover" />,
  },
  {
    id: 'historyMenuItem',
    label: lang.commonTitleHistory(),
    path: UI_ROUTES.tradeHistory,
    img: <img src={ordersTradersLogo} alt="icon up and down arrows" />,
  },
  {
    id: 'myPositionMenuItem',
    label: lang.commonMyPositionRanking(),
    path: UI_ROUTES.myPosition,
    img: <img src={IconCup} alt="icon up and down arrows" />,
  },
];

export const SUPPORT_LIST: SideBarItem[] = [
  {
    id: 'helpCenterMenuItem',
    label: lang.myProfileHelpCenter(),
    path: '',
    img: <img src={helpLogo} alt="icon help Logo" />,
  },
];
